import { useMemo } from 'react'

import ProfilePhoto from 'src/shared/assets/images/profile-avatar-fallback.png'
import { formatMessageTime } from 'src/shared/utils/dates/format-message-time'

import type { UserZillowReview } from '../../../api/marketplace/use-user-reviews'
import { MiniZillow } from '../../../assets/mini-zillow'
import { ReviewStar } from '../../../assets/review-star'
import { getNumberOfStars } from '../util/get-number-of-stars'

const PublicPageReviewCard = ({ review }: { review: UserZillowReview }) => {
  const descriptionText = useMemo(() => {
    if (!review.serviceDescription) return ''

    if (!review.locationZipcode) return review.serviceDescription

    return `${review.serviceDescription} in ${review.locationZipcode}`
  }, [review.serviceDescription, review.locationZipcode])

  const dateText = useMemo(() => {
    if (!review.date) return ''
    // return new Date(review.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    return formatMessageTime(review.date)
  }, [review.date])

  return (
    <div
      className="w-full min-w-[280px] max-w-[calc(100vw-40px)] rounded-2xl border bg-white p-4 md:min-w-[325px] md:max-w-none"
      style={{
        boxShadow: '0px 3px 10px 1px rgba(220, 219, 218, 0.25)',
      }}
    >
      <div className="flex items-center gap-3">
        <img src={ProfilePhoto} alt="" className="size-[50px] rounded-full object-cover" />
        <div>
          <div className="font-semibold text-black">{review.reviewerFullName || 'Anonymous'}</div>
          <div className="text-xs text-muted">{descriptionText}</div>
        </div>
      </div>
      <div className="mt-3 text-[13px] text-black md:text-[15px]">{review.description}</div>
      <div className="mt-3 flex flex-row items-center gap-2 text-xs text-muted md:text-sm">
        <MiniZillow size={15} />
        <span className="flex flex-row gap-0.5">
          {[...Array(getNumberOfStars(review.rating ?? 0))].map((_, index) => (
            <ReviewStar key={index} size={15} pattern="gold" />
          ))}
        </span>
        <span>{' • '}</span>
        <span>{dateText}</span>
      </div>
    </div>
  )
}

export default PublicPageReviewCard
